/**
 * ChatGreeting Component - Gemini-Inspired Design
 * Beautiful greeting with "Hi [Name], Where should we start?" style
 */
import React from 'react';
import { useUser } from '@clerk/clerk-react';
import './ChatGreeting.css';

const ChatGreeting = ({ onSuggestionClick }) => {
  const { user } = useUser();

  const getFirstName = () => {
    if (user?.firstName) return user.firstName;
    if (user?.username) return user.username;
    if (user?.fullName) return user.fullName.split(' ')[0];
    return 'there';
  };

  return (
    <div className="chat-greeting">
      <div className="greeting-icon">
        <img src="/tuliza.jpg" alt="Tuliza" className="greeting-tuliza-icon" />
      </div>

      <h1 className="greeting-title">
        <span className="greeting-hi">Hi {getFirstName()}, where should we start?</span>
      </h1>
    </div>
  );
};

export default ChatGreeting;
